
/*
 * VivaGuard Image Fly-In
 * Images remain exactly the same; once an image has actually loaded,
 * it smoothly flies into its existing position.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const selector = 'img';

  const shouldAnimate = (img) => {
    if (!img || img.dataset.vivaguardRevealBound === 'true') return false;
    if (img.closest('svg, .shopify-section-header, header, footer')) return false;
    if (img.classList.contains('icon') || img.classList.contains('logo')) return false;

    const rect = img.getBoundingClientRect();
    const width = rect.width || img.width || 0;
    const height = rect.height || img.height || 0;

    // Skip tiny UI images/icons.
    if (width < 80 || height < 40) return false;

    return true;
  };

  const prepare = (img) => {
    if (!shouldAnimate(img)) return;

    img.dataset.vivaguardRevealBound = 'true';

    const rect = img.getBoundingClientRect();
    const center = window.innerWidth / 2;
    const imageCenter = rect.left + rect.width / 2;

    // Left images enter gently from the left, right images from the right,
    // and centered images rise slightly from below.
    let enterX = 0;
    let enterY = 24;

    if (Math.abs(imageCenter - center) > window.innerWidth * 0.12) {
      enterX = imageCenter < center ? '-28px' : '28px';
      enterY = 8;
    }

    img.style.setProperty('--vg-enter-x', enterX);
    img.style.setProperty('--vg-enter-y', `${enterY}px`);
    img.classList.add('vivaguard-image-reveal');

    const reveal = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          img.classList.add('vivaguard-image-loaded');
        });
      });
    };

    if (img.complete && img.naturalWidth > 0) {
      reveal();
    } else {
      img.addEventListener('load', reveal, { once: true });
      img.addEventListener('error', () => {
        img.classList.add('vivaguard-image-loaded');
      }, { once: true });
    }
  };

  const scan = (root = document) => {
    root.querySelectorAll(selector).forEach(prepare);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  // Covers Shopify sections, quick views, predictive search and other
  // content injected after the initial page load.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.(selector)) prepare(node);
        node.querySelectorAll?.(selector).forEach(prepare);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
